/*
 * @Descripttion: 
 * @version: 
 * @Author: pan
 * @Date: 2020-02-25 09:58:19
 * @LastEditTime: 2020-03-20 23:58:25
 */
/* eslint-disable jsx-a11y/alt-text */
/* 图片签名模式改变，改用公共组件het-sign-img,(如下载有问题单独下载该依赖)
详情见http://10.8.17.28/package/het-sign-img
 */
import React from "react";
import PropTypes from "prop-types";
import Reflux from "reflux";
import DefaultImg from "static/knowledge/default.png";
import SignImg,{signElement} from 'het-sign-img';


class Image extends Reflux.Component {
  constructor(props) {
    super(props);
  
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
    
  }

  render() {
    const newProps = { ...this.props };
    const { src, imageStyle,div } = newProps;
    delete newProps.src;
    if(src&&src.indexOf("data:image/png")>-1){
      return <img {...newProps} src={src} />
    }
    // console.log("src",src)
    if(div){
      const SignDiv = new signElement('div') //参数为dom元素字符串 或者 组件
        return <SignDiv
          {...newProps}
          style={{
            backgroundImage: `url(${
              src||DefaultImg
            }) `,
            backgroundPositon:"center",
            backgroundSize:"cover",
            backgroundRepeat:"no-repeat",
            ...newProps.style
          }}
        />
    }
    return (
      <SignImg
        {...newProps}
        style={Object.assign(newProps.style || {}, imageStyle)}
        src={src||DefaultImg}
        alt="图片加载失败"
      />
    );
  }
}
export default Image;
Image.defaultProps = {
  div: false,
  isVideo: false,
  src: "",
  isExpress: false, // 是否是缩略图，默认非缩略
  defaultPath: "imageView2/1/w/320"
};
Image.propTypes = {
  isVideo: PropTypes.bool,
  div: PropTypes.bool,
  src: PropTypes.string,
  isExpress: PropTypes.bool,
  defaultPath: PropTypes.string
};
